import camelCase from 'lodash.camelcase';
import * as React from 'react';

import i18n from 'helper/i18n';

import { FAME_BADGE_MODIFIERS } from 'components/molecules/Fame/Badge';
import { FameBadgeProps } from 'components/molecules/Fame/Badge';
import FameBadge from 'containers/molecules/Fame/Badge/FameBadge';

type FameSuccessProps = {
	badges: { code: string; eventLevel: string; awardedDateTime: any }[]; // FameBadgeProps[];
	awardedSpecialBadges: FameBadgeProps[];
};

export default class FameSuccess extends React.Component<FameSuccessProps> {
	public static displayName = 'Fame(Success)';

	public renderBadges() {
		const badges = this.props.badges;
		const last = this.props.badges.length - 1;

		return badges.map((badgeProps, index) => {
			const label = i18n(
				`react.impulsCoach.events.badge.${camelCase(badgeProps.code)}.${camelCase(badgeProps.eventLevel)}.title`
			);

			return (
				<div key={`${badgeProps.code}-${index}`} className={'col-xs-6 col-sm-4'}>
					<div className={`m-fame-success__badge${index === last ? ' m-fame-success__badge--last' : ''}`}>
						<FameBadge
							award={{
								eventLevel: badgeProps.eventLevel,
								code: badgeProps.code,
								awardedDateTime: badgeProps.awardedDateTime,
							}}
							modifier={FAME_BADGE_MODIFIERS.OVERLAY}
							label={label}
						/>
					</div>
				</div>
			);
		});
	}

	public render() {
		const { badges } = this.props;
		return (
			<div className="m-fame-success">
				<div className="m-fame-success__bg">
					<div className="m-fame-success__content">
						<div className="container container--full-width-ms">
							<div className="row">
								<div className="col-xs-12">
									<h2 className="m-fame-success__title">
										{i18n('react.impulsCoach.components.fameSuccess.title')}{' '}
										<span className="m-fame-success__count">
											{i18n('react.impulsCoach.components.fameSuccess.countText', {
												current: this.props.awardedSpecialBadges.length,
												total: this.props.badges.length,
											})}
										</span>
									</h2>
								</div>
							</div>
							<div className="row">
								<div className="m-fame-success__badges">
									{badges.length !== 0 && this.renderBadges()}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
